'use client';

import React, { useState } from 'react';
import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import { LoginForm } from '@/components/LoginForm/LoginForm';
import { setTokens } from '@/tokenManager';
import LoginWrapper from './LoginWrapper';
import { fetchWithRedirect } from '@/helpers/fetchWithRedirect';
import { LoginTokens } from '@/helpers/auth';

export default function Login() {
  const t = useTranslations('Login');
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string>();

  const handleLogin = async ({
    email,
    password,
    remember,
  }: {
    email: string;
    password: string;
    remember: boolean;
  }) => {
    if (loading) return;
    setErrorMsg(undefined);
    setLoading(true);

    try {
      const res = await fetchWithRedirect<{ data: LoginTokens }>('auth/login', {
        method: 'POST',
        body: JSON.stringify({ email: email.trim(), password }),
        headers: { 'Content-Type': 'application/json' },
      });

      if (res.redirected) {
        window.location.href = res.redirectUrl!;
        return;
      }
      if (res.error) throw new Error(res.error);

      const data = res.data?.data;
      if (data) {
        setTokens(data, remember);
        router.refresh();
      }
    } catch (err: any) {
      setErrorMsg(err?.message ?? t('Login failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <LoginWrapper
      heading={t('Welcome')}
      subtitle={t('Enter your email and password to access your account')}
    >
      <LoginForm
        onSubmit={handleLogin}
        loading={loading}
        errorMessage={errorMsg}
        forgotPasswordHref='/login/forgot'
        startJourneyHref='/'
      />
    </LoginWrapper>
  );
}
